import Box from './Box';
import Home from './Home';
import FHEProduct from './Product';
import PushNotification from './PushNotification';

export default socketMiddleware => {
    return Object.assign({}, FHEProduct(socketMiddleware), Home(socketMiddleware), Box(socketMiddleware), PushNotification(socketMiddleware));
};



// WEBPACK FOOTER //
// ./environments/genericEnv/eventsSocket/index.js